export default __webpack_public_path__ + "static/media/011-sport bra.7f0b241f.svg";